import {combineReducers} from '@reduxjs/toolkit';
import {authenticated} from 'feedback-system/auth/reducers';
import {consolidatedFB} from '../modules/feedback-consolidation/services/reducers';
import {statisticReducer} from '../modules/feedback-overview';
import {qualityFeedbackReducer} from '../modules/quality-feedback/services/reducers';
import {searchUserReducer} from '../modules/quality-feedback/add-user/add-user-dialog/services/reducers';
import {periods} from '../modules/main-container/services/reducers';
import emloyeesReducer from '../modules/employees/services/reducers';
import {exportMenu} from '../modules/feedback-consolidation/export-menu/services/reducers';
import {sync} from '../modules/admin/services/reducers';
import authReducer from '../modules/login/services/reducers';

const rootReducer = combineReducers({
    authenticated,
    qualityFeedbackReducer,
    statisticReducer,
    consolidatedFB,
    searchUserReducer,
    periods,
    exportMenu,
    emloyeesReducer,
    authReducer,
    sync
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>

